/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { employee_selfservice_MyShiftGroupResponse } from './employee_selfservice_MyShiftGroupResponse';
export type employee_selfservice_MyShiftResponse = {
    /**
     * Optional break end (HH:MM)
     */
    breakEnd?: string;
    /**
     * Break duration in minutes
     */
    breakMinutes: number;
    /**
     * Optional break start (HH:MM)
     */
    breakStart?: string;
    /**
     * When the shift last changed after publication, as pushed to the employee (#2038)
     */
    changedAfterPublishAt?: string;
    /**
     * When the shift was confirmed (#2038); absent unless CONFIRMED
     */
    confirmedAt?: string;
    /**
     * End time (HH:MM)
     */
    endTime: string;
    /**
     * Groups the shift is assigned to
     */
    groups: Array<employee_selfservice_MyShiftGroupResponse>;
    /**
     * Shift id
     */
    id: string;
    /**
     * When the shift was last published (#2038)
     */
    publishedAt?: string;
    /**
     * Shift date (YYYY-MM-DD), local to the organisation
     */
    shiftDate: string;
    /**
     * Start time (HH:MM)
     */
    startTime: string;
    /**
     * Shift status; PUBLISHED, CONFIRMED, or CANCELLED for a shift that had been published (#2038)
     */
    status: employee_selfservice_MyShiftResponse.status;
};
export namespace employee_selfservice_MyShiftResponse {
    /**
     * Shift status; PUBLISHED, CONFIRMED, or CANCELLED for a shift that had been published (#2038)
     */
    export enum status {
        PUBLISHED = 'PUBLISHED',
        CONFIRMED = 'CONFIRMED',
        CANCELLED = 'CANCELLED',
    }
}

